import React from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import { detailparcelleStyles } from "./styles";
import { useState, useEffect } from "react";
import { useToast } from "../../../Context/ToastContext";
import { useTransactionsAndFaos } from "../../../Context/crm/TransactionsAndFaosContext";
import { faosService } from "../../../service/FaosService";

/*****Ui icons */
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const EnqueteDetail = ({ details }) => {
  const { faos, setFaos } = useTransactionsAndFaos();
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChanges = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const toaster = useToast();

  const fetchData = async () => {
    if (!details) return;

    setLoading(true);

    try {
      const landId = details.old_lands_id;

      // Appel au service
      const enquetes = await faosService.findByLandId(landId);

      // 🔹 Log des enquêtes reçues
      console.log("Enquêtes reçues :", enquetes);

      setFaos(enquetes.data ?? []);
    } catch (error) {
      console.error("Erreur lors de la requête API :", error);
      toaster.notifyError("Erreur : " + error.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [details]);

  useEffect(() => {
    setLoading(false);
  }, [faos]);

  const renderFaos = (faos) => {
    if (faos && faos.length > 0) {
      console.log("FAOS reçues: ", faos);
      return faos.map((fao) => renderFaosLine(fao));
    }

    return <Typography variant="body1">Pas d'enquête disponible</Typography>;
  };

  const renderFaosLine = (enquete) => {
    return (
        <Accordion
            expanded={expanded === enquete.old_new_enquetes_id}
            onChange={handleChanges(enquete.old_new_enquetes_id)}
            key={enquete.old_new_enquetes_id}
            sx={{ pb: 0 }}
        >
          <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<ExpandMoreIcon />}
              sx={detailparcelleStyles.accordions}
          >
            <Typography
                sx={{
                  width: "33.3%",
                  textAlign: "start",
                  ...detailparcelleStyles.mobileTitleSpacing,
                  color: "#0D0D0D",
                  fontWeight: "bold",
                }}
            >
              {enquete.type}
            </Typography>
            <Typography sx={{ width: "33.3%", textAlign: "center" }}>
              {enquete.nature_ouvrage}
            </Typography>
            <Typography
                sx={{
                  width: "33.3%",
                  textAlign: "right",
                  color: "#000000",
                  fontWeight: "bold",
                }}
            >
              {enquete.numero_requete || "—"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ p: 2 }}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Détails de l'enquête
                </Typography>
                <Box sx={{ pl: 2 }}>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Type :
            </span>{" "}
                    {enquete.type}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Description :
            </span>{" "}
                    {enquete.nature_ouvrage}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Architecte :
            </span>{" "}
                    {enquete.mandataire}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Propriétaire(s) :
            </span>{" "}
                      {enquete.proprietaire || "—"}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Zone de construction :
            </span>{" "}
                    {enquete.zone_construction || "—"}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Commune :
            </span>{" "}
                    {enquete.commune || "—"}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Numéro parcelle(s) :
            </span>{" "}
                    {enquete.no_parcelle.join(", " ) || "—"}
                  </p>
                  <p>
            <span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>
              Canton :
            </span>{" "}
                    {enquete.canton || "—"}
                  </p>
                </Box>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

    );
  };

  return (
    <Box className="Layout bg-white my-4 rounded p-4" id="enquete">
      <Typography variant="h6" style={detailparcelleStyles.fontWeightTitle}>
        ENQUÊTES
      </Typography>
      <Box sx={{ p: 1, mt: 2 }}>
        {loading ? <CircularProgress /> : renderFaos(faos)}
      </Box>
    </Box>
  );
};

export default EnqueteDetail;
